import { Action } from 'redux';
import { Medico } from '../../../models/Entities/Turnero';
import { TurneroMedicosState, TurneroMedicosUnloadState } from '../../states/Turnero-Medicos.State';

export default function TurneroMedicosReducer(
    state: TurneroMedicosState | undefined,
    action: Action
): TurneroMedicosState {
    const currentState = state ?? TurneroMedicosUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-MEDICOS_GET_ALL_REQUEST':
            return {
                ...currentState,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_GET_ALL_SUCCESS':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: a.payload || []
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_GET_ALL_FAILURE':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: a.error
            } as TurneroMedicosState;

        case 'TURNERO-MEDICOS_CREATE_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_CREATE_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_CREATE_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroMedicosState;

        case 'TURNERO-MEDICOS_GET_BY_ID_REQUEST':
            return {
                ...currentState,
                isLoadingOne: true,
                successLoadingOne: false,
                failOnLoadingOne: false,
                error: undefined
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_GET_BY_ID_SUCCESS': {
            const updatedList = [...(currentState.list || []).filter((m: Medico) => m.id !== a.payload.id), a.payload];
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                error: undefined,
                current: a.payload,
                list: updatedList
            } as TurneroMedicosState;
        }
        case 'TURNERO-MEDICOS_GET_BY_ID_FAILURE':
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: a.error
            } as TurneroMedicosState;

        case 'TURNERO-MEDICOS_UPDATE_REQUEST':
            return {
                ...currentState,
                isUpdatingOne: true,
                successUpdatingOne: false,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_UPDATE_SUCCESS':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_UPDATE_FAILURE':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: a.error
            } as TurneroMedicosState;

        case 'TURNERO-MEDICOS_DELETE_REQUEST':
            return {
                ...currentState,
                isDeletingOne: true,
                successDeletingOne: false,
                failOnDeletingOne: false,
                error: undefined
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_DELETE_SUCCESS':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                error: undefined,
                list: (currentState.list || []).filter((m: Medico) => m.id !== a.payload)
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_DELETE_FAILURE':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: a.error
            } as TurneroMedicosState;

        case 'TURNERO-MEDICOS_GET_CONFIG_REQUEST':
            return {
                ...currentState,
                isLoadingConfig: true,
                successLoadingConfig: false,
                failOnLoadingConfig: false,
                error: undefined
            } as TurneroMedicosState;
        case 'TURNERO-MEDICOS_GET_CONFIG_SUCCESS': {
            const nextConfig = { ...(currentState.configuracion || {}) };
            nextConfig[a.medicoId] = a.payload;
            return {
                ...currentState,
                isLoadingConfig: false,
                successLoadingConfig: true,
                failOnLoadingConfig: false,
                error: undefined,
                configuracion: nextConfig
            } as TurneroMedicosState;
        }
        case 'TURNERO-MEDICOS_GET_CONFIG_FAILURE':
            return {
                ...currentState,
                isLoadingConfig: false,
                successLoadingConfig: false,
                failOnLoadingConfig: true,
                error: a.error
            } as TurneroMedicosState;

        default:
            return currentState as TurneroMedicosState;
    }
}
